import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { validateField } from "../../contexts/Utils";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GetSerializedById,
  GetSerializedByParentSn,
  GetOpenSOListByStore,
  GetUnAssignedSerializedByStoreCompanyFilter,
  GetSerializedBySo,
  EditSerializedParentSnApi,
  EditSerializedSoApi,
} from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import { Col, Container, Row } from "react-bootstrap";
import "../../styles/AddPart.css";
import { usePromiseTracker, trackPromise } from "react-promise-tracker";
import LoadingIndicator from "../LoadingIndicator";
import TextInputField from "../../components/TextInputField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";
import AsyncSelectField from "../../components/AsyncSelectField";
import SelectField from "../../components/SelectField";
import DateInputField from "../../components/DateInputField";

const AssignSerialized = () => {
  const navigate = useNavigate();
  const { storeG, companyG } = useStateContext();
  let param = useParams();
  const parent_id = param.parent_id || 0;
  const [partOptions, setPartOptions] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [Parent, setParent] = useState("");
  const [storeId, setStoreId] = useState(0);
  const [companyId, setCompanyId] = useState(0);
  const [soIds, setSoIds] = useState([]);
  const { promiseInProgress } = usePromiseTracker();
  const [loading, setloading] = useState(true);
  const [loadBtn, setLoadBtn] = useState(false);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    part: "select",
    so: "select",
    ship_date: "",
  });

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Serialized");
  };

  const handleDeleteClick = (index) => {
    TimeoutUtility.resetTimeout();
    const remProd = itemList[index];
    if (window.confirm(`Do you want to remove ${remProd.sn} from the list?`)) {
      const newCartList = [...itemList];
      newCartList.splice(index, 1);
      setItemList(newCartList);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = async (option, e) => {
    if (option && option.value) {
      if (e.name === "so") {
        trackPromise(
          GetSerializedBySo(option.value)
            .then(([result]) => {
              if (result.data && result.data.length > 0) {
                const productList = result.data.map((item) => ({
                  sn_id: item.sn_id,
                  part_id: item.part_id,
                  part_number: item.part_number,
                  sn: item.sn,
                  mfg_sn: item.mfg_sn,
                  po_id: item.po_id,
                  recv_date: item.receive_date,
                }));
                setItemList(() => [...productList]);
              }
            })
            .catch((err) => console.log(err.message))
            .finally(() => setloading(false)),
        );
      }
      setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const loadOptions = async (inputText, callback) => {
    if (inputText.length > 2) {
      await GetUnAssignedSerializedByStoreCompanyFilter(
        storeId,
        companyId,
        inputText,
      )
        .then((resp) => {
          const partOptions1 = resp.data.map((item) => ({
            label: item.mfg_sn
              ? `${item.sn} - ${item.mfg_sn} - ${item.part_number}`
              : `${item.sn} - ${item.part_number}`,
            value: item.sn_id,
            part_id: item.part_id,
            part_number: item.part_number,
            sn: item.sn,
            mfg_sn: item.mfg_sn,
            po_id: item.po_id,
            recv_date: item.receive_date,
          }));
          setPartOptions(partOptions1 || []);
          callback(partOptions1 || []);
        })
        .catch((err) => console.log(err.message));
    } else callback(partOptions);
  };

  const handleAddItemClick = (e) => {
    e.preventDefault();
    const newErrors = {};
    if (formData.part === "select" || !formData.part?.value)
      newErrors["part"] = "Please select Part!";
    if (!newErrors["part"]) {
      if (itemList.some((item) => item.sn_id === formData.part.value))
        newErrors["part"] = "This Serialized Part is already in the list!";
      if (parseInt(parent_id) === parseInt(formData.part.value))
        newErrors["part"] = "Part cannot be same as Parent Part!";
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    setFormData((prev) => ({ ...prev, part: "select" }));
    setItemList((prev) => [
      ...prev,
      {
        sn_id: formData.part.value,
        part_id: formData.part.part_id,
        part_number: formData.part.part_number,
        sn: formData.part.sn,
        mfg_sn: formData.part.mfg_sn,
        po_id: formData.part.po_id,
        recv_date: formData.part.recv_date
          ? formData.part.recv_date.split("T")[0]
          : "-",
      },
    ]);
  };

  const handleUpdateBOMClick = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);

    if (itemList.length === 0) {
      showErrorToast("Error!", "Add one or more Serialized Parts to assign!");
      setLoadBtn(false);
      return;
    }
    let childParts = [];
    itemList.forEach((part) => {
      childParts.push(part.sn_id);
    });
    try {
      if (parent_id !== 0) {
        const response = await EditSerializedParentSnApi(parent_id, childParts);
        if (response.success) {
          showSuccessToast("Success!", "Parent assigned successfully.");
          navigate("/Serialized");
        } else
          showErrorToast(
            "Error!",
            "Parent failed to assign!\n\n" + response.message,
          );
      } else {
        const newErrors = {};
        const keys = ["so", "ship_date"];
        keys.forEach((key) => {
          const error = validateField(key, formData[key], key);
          if (error) newErrors[key] = error;
        });
        setErrors(newErrors);
        if (Object.keys(newErrors).length > 0) {
          setLoadBtn(false);
          return;
        }

        const response = await EditSerializedSoApi(
          formData.so.value,
          formData.ship_date || null,
          childParts,
        );
        if (response.success) {
          showSuccessToast("Success!", "Parent assigned successfully.");
          navigate("/Serialized");
        } else
          showErrorToast(
            "Error!",
            "Parent failed to assign!\n\n" + response.message,
          );
      }
    } catch (err) {
      showErrorToast("Error!", "Parts failed to assign!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (storeG?.store_id && companyG?.company_id && parent_id === 0) {
        setloading(true);
        var now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        setFormData((prev) => ({
          ...prev,
          ship_date: now.toISOString().slice(0, 19).split("T")[0],
        }));
        trackPromise(
          GetOpenSOListByStore(storeG.store_id)
            .then((result) => {
              const soOptions = result.data.map((item) => ({
                label: `S` + item.so_id,
                value: item.so_id,
                sale_date: item.sale_date,
              }));
              setSoIds(soOptions || []);
              setStoreId(storeG.store_id);
              setCompanyId(companyG.company_id);
            })
            .catch((err) => console.log(err.message))
            .finally(() => setloading(false)),
        );
      }
    }
    fetchData();
  }, [parent_id, storeG, companyG]);

  useEffect(() => {
    async function fetchData() {
      if (parent_id !== null) {
        setloading(true);
        if (parent_id !== 0) {
          trackPromise(
            Promise.all([
              GetSerializedById(parent_id),
              GetSerializedByParentSn(parent_id),
            ])
              .then(([result1, result2]) => {
                setParent(
                  result1.data.mfg_sn
                    ? `${result1.data.sn} - ${result1.data.mfg_sn} - ${result1.data.part_number}`
                    : `${result1.data.sn} - ${result1.data.part_number}`,
                );
                setStoreId(result1.data.store_id);
                setCompanyId(result1.data.company_id);
                if (result2.data && result2.data.length > 0) {
                  const productList = result2.data.map((item) => ({
                    sn_id: item.sn_id,
                    part_id: item.part_id,
                    part_number: item.part_number,
                    sn: item.sn,
                    mfg_sn: item.mfg_sn,
                    po_id: item.po_id,
                    recv_date: item.receive_date,
                  }));
                  setItemList(() => [...productList]);
                }
              })
              .catch((err) => console.log(err.message))
              .finally(() => setloading(false)),
          );
        }
      }
    }
    fetchData();
  }, [parent_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header
        title={parent_id !== 0 ? `ASSIGN PARENT SN` : `ASSIGN SALES ORDER`}
      />
      <Container className="g-0 form-container" fluid="true">
        <Row xs={1} sm={1} className="justify-content-center">
          {loading && promiseInProgress ? (
            <LoadingIndicator />
          ) : parent_id !== 0 ? (
            <Col md={8} className="container-col">
              <TextInputField
                label="Parent Serialized Part:"
                name="parent"
                value={Parent}
                placeholder="Parent Serialized Part"
                disabled
              />
            </Col>
          ) : (
            <>
              <Col md={4} className="container-col">
                <SelectField
                  label="SO #:"
                  name="so"
                  value={formData.so}
                  options={soIds}
                  onChange={handleSelectChange}
                  placeholder="SO #"
                  compulsory={true}
                  error={errors.so}
                  autoFocus
                />
              </Col>
              <Col md={4} className="container-col">
                <DateInputField
                  label="Ship Date:"
                  name="ship_date"
                  value={formData.ship_date}
                  onChange={handleChange}
                  placeholder="Ship Date"
                  compulsory={true}
                  error={errors.ship_date}
                />
              </Col>
            </>
          )}
          <Col md={12} className="container-col pt-8 ml-12">
            <label className="label" style={{ fontSize: "20px" }}>
              Parts List:
            </label>
          </Col>
          <Row className="pl-2 pr-2 pb-4 justify-content-center">
            <Col md={7} className="container-col">
              <AsyncSelectField
                label="Unassigned Serialized Part:"
                name="part"
                value={formData.part}
                loadOptions={loadOptions}
                // options={partOptions}
                onChange={handleSelectChange}
                placeholder="Unassigned Serialized Part"
                compulsory={true}
                error={errors.part}
                autoFocus
              />
            </Col>
            <Col md={1} className="container-col pt-6">
              <Button
                margin="10px"
                padding="20px"
                text="Assign"
                onClick={handleAddItemClick}
                disabled={loadBtn}
              />
            </Col>
          </Row>
          <Col md={12}>
            <Row xs={1} sm={1} className="justify-content-center pl-3 pr-3">
              <div
                className="m-0 p-0 table-container-sale"
                style={{ height: "44vh" }}
              >
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr className="table-sale-tr">
                      <th style={{ width: "80px" }}>PART NO</th>
                      <th style={{ width: "100px" }}>SN</th>
                      <th style={{ width: "120px" }}>MFG SN</th>
                      <th style={{ width: "50px" }}>PO #</th>
                      <th style={{ width: "80px" }}>RECV DATE</th>
                      <th style={{ width: "30px" }}>DEL</th>
                    </tr>
                  </thead>
                  <tbody className="pos-table-body1">
                    {itemList?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.part_number}</td>
                        <td>{item.sn}</td>
                        <td>{item.mfg_sn}</td>
                        <td>P{item.po_id}</td>
                        <td>{item.recv_date}</td>
                        <td>
                          <button onClick={() => handleDeleteClick(index)}>
                            ❌
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Row>
          </Col>
        </Row>
      </Container>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Update"
          onClick={handleUpdateBOMClick}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default AssignSerialized;
